'use client';

import Image from "next/image";
import Link from "next/link";
import styles from './index.module.scss';
import MainButton from "@/app/_components/Shared/MainButton";
import DashboardChart from '@/app/images/DashboardChart.png';

export default function HeroLandingSection() {
  return (
    <section className={styles.container}>
      <div className="container-wrapper">
        <div className={styles.grid}>
          {/* Left Content */}
          <div className={styles.content}>
            <div className={styles.badge}>
              PRO Services Excellence
            </div>

            <h1 className={styles.title}>
              Build your business with <span className={styles.highlight}>Digital</span> PRO Services
            </h1>

            <p className={styles.description}>
              Carrying forward the mission of cashless and digitalization. Deploy smarter, faster PRO services that make your online interactions smoother and faster. We are definitely your go-to partner in Dubai.
            </p>

            <div className={styles.buttons}>
              <Link href="/pro-services-request">
                <MainButton color="info">
                  Get Started
                  <svg className={styles.buttonIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </MainButton>
              </Link>
              <Link href="/about-us">
                <MainButton color="white">
                  Learn More
                </MainButton>
              </Link>
            </div>

            {/* Stats */}
            <div className={styles.stats}>
              <div className={styles.stat}>
                <div className={styles.statValue}>500+</div>
                <div className={styles.statLabel}>Active Clients</div>
              </div>
              <div className={styles.stat}>
                <div className={styles.statValue}>24/7</div>
                <div className={styles.statLabel}>Support</div>
              </div>
              <div className={styles.stat}>
                <div className={styles.statValue}>99%</div>
                <div className={styles.statLabel}>Satisfaction</div>
              </div>
            </div>
          </div>

          {/* Right Dashboard Mockup */}
          <div className={styles.imageWrapper}>
            <Image
              src={DashboardChart}
              alt="Dashboard Analytics"
              width={600}
              height={500}
              className={styles.image}
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
}
